<vectronic-card
  [title]="'Reset to factory confirmation'"
  [displayClose]="true"
  (closed)="dialogRef.close()"
  (resized)="onResized($event)"
  [showResize]="true"
>
  <ng-container body>
    <div class="parameter-reset-dialog">
      <p>
        Are you sure you want to reset parameter data list for device {{ joinedSelectedCollarIds }}?
      </p>
      @if (data.parameterDataList) {
        <vectronic-parameter-view
          [parameters]="data.parameters$ | async"
          [categories]="data.categories$ | async"
          [subsystems]="data.subsystems$ | async"
        ></vectronic-parameter-view>
      }
    </div>
    <div class="parameter-reset-dialog__action-button">
      <button mat-button (click)="onCancel()">
        <mat-icon color="warn">close</mat-icon>
        Cancel
      </button>
      <button mat-button (click)="onConfirm()">
        <mat-icon color="accent">send</mat-icon>
        Confirm
      </button>
    </div>
  </ng-container>
</vectronic-card>
